interface Props {
  color: string;
  size: number;
}

export function SensorPro({ color, size }: Props) {
  return (
    <svg width={22 * size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10.45" fill="white" stroke={color} strokeWidth="1.1" />
      <circle cx="12" cy="12" r="11.2" stroke="#323B37" strokeWidth="0.4" />
      <circle cx="12" cy="12" r="8" fill={color} />
    </svg>
  );
}
